<template>
    <div class="form-group">
      <div :class="hasIcon(icon)">
        <span v-if="iconDir === 'left'" class="input-group-text">
          <i :class="getIcon(icon)"></i>
        </span>
        <input
          type="number"
          class="form-control"
          :class="getClasses(size, valid)"
          :name="name"
          :id="id"
          :value="modelValue"
          :placeholder="placeholder"
          :isRequired="isRequired"
          :min="min"
          :max="max"
          @input="onInput"
        />
        <p v-show="errorMessage" class="form__error">{{ errorMessage }}</p>
        <span v-if="iconDir === 'right'" class="input-group-text">
          <i :class="getIcon(icon)"></i>
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "argon-input-number",
    props: {
      size: {
        type: String,
        default: "default",
      },
      valid: {
        type: Boolean,
        default: false,
      },
      min:String,
      max:String,
      icon: String,
      iconDir: String,
      name: String,
      id: String,
      value: String,
      modelValue: {
        type: String,
        default: "",
      },
      placeholder: String,
      type: String,
      isRequired: Boolean,
      errorMessage: {
        type: String,
        required: false
      },
    },
    emits:["update:modelValue"],
    methods: {
      getClasses: (size, valid) => {
        let sizeValue, isValidValue;
  
        sizeValue = size ? `form-control-${size}` : null;
  
        isValidValue = valid ? `${valid}` : "invalid";
  
        return `${sizeValue} ${isValidValue}`;
      },
      getIcon: (icon) => (icon ? icon : null),
      hasIcon: (icon) => (icon ? "input-group" : null),
      onInput(e){
        this.$emit("update:modelValue",e.target.value)
      },
    },
  };
  </script>
  